// Detect if user is from the UK and show a popup to redirect to .co.uk
(function () {
    let currentCountry = "";
    let currentCountryCode = "";

    function isNonUSVisitor() {
        return fetch("browsing_context_suggestions.json")
            .then(function (response) {
                return response.json();
            })
            .then(function (data) {
                currentCountry = data.detected_values.country_name;
                currentCountryCode = data.detected_values.country.handle;
                return (
                    data &&
                    data.detected_values.country.handle !== "US" &&
                    data.detected_values.country.handle !== "CA"
                );
            })
            .catch(function () {
                return false;
            });
    }

    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(";").shift();
        return null;
    }

    function setSessionCookie(name, value) {
        document.cookie = `${name}=${value}; path=/; SameSite=Lax;`;
    }

    function showRedirectPopup() {
        setSessionCookie("redirect_popup_shown", "1");

        const popup = document.getElementById("redirect-popup");
        const flagHtml = window.countryFlags?.[currentCountryCode] || "";
        popup.querySelector(".redirect-popup__image").innerHTML = flagHtml;
        popup.querySelector("#redirect-popup__title span").innerHTML =
            currentCountry;

        popup.classList.add("redirect-popup--active");

        document.getElementById("redirect-popup__close").onclick =
            function onCloseClick() {
                popup.classList.remove("redirect-popup--active");
                document.querySelector("body").focus();
            };
        document.getElementById("redirect-popup__close").focus();
    }

    if (!getCookie("redirect_popup_shown")) {
        isNonUSVisitor().then(function handleNonUS(isNotUs) {
            if (isNotUs) showRedirectPopup();
        });
    }
})();
